import { useEffect } from 'react';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { getTeamsNames } from './views/CustomReport/Filters/TeamsDropdown';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useFilters from './useFilters';
import useDashboards from './useDashboards';
import useSettingsService from 'components/hooks/useSettingsService';
import { getAccounts } from 'state/callers';
import { useDispatch } from 'react-redux';
import { setSelectedTeamChangedFromTopBar } from 'state/actions/ui-state';

const usePerformance = ({ disableTeamPicker, setDisableTeamPicker }) => {
  const dispatch = useDispatch();
  const filters = useFilters();
  const dashboards = useDashboards({
    filters,
    disableTeamPicker,
    setDisableTeamPicker
  });
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isCustomPmMetricsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isCustomPmMetricsEnabled
  });

  const shouldHideProjectManagement = isCustomPmMetricsEnabled;

  const getAllAccounts = async () => {
    await getAccounts()(dispatch);
  };

  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
      page: TRACKING.PAGES.METRICS,
      team_names: getTeamsNames(filters.globallySelectedTeams)
    });
    getAllAccounts();

    window.scrollTo({ top: 0, behavior: 'instant' });
    return () => {
      dispatch(setSelectedTeamChangedFromTopBar(false));
    };
  }, []);

  return {
    sideBarDashboards: dashboards.sideBarDashboards,
    loaded: dashboards.loaded,
    newCustomDashBoard: dashboards.newCustomDashBoard,
    selectedReport: dashboards.selectedReport,
    onSelectReport: dashboards.onSelectReport,
    setNewCustomDashBoard: dashboards.setNewCustomDashBoard,
    generateNewReport: dashboards.generateNewReport,
    setSelectedReport: dashboards.setSelectedReport,
    maxDashboards: dashboards.maxDashboards,
    newFormattedBoard: dashboards.newFormattedBoard,
    reports: dashboards.reports,
    customDashboardsFiltered: dashboards.customDashboardsFiltered,
    pinnedDashboards: dashboards.pinnedDashboards,
    canCreateMoreCustomDashboards: dashboards.canCreateMoreCustomDashboards,
    isCustomPmMetricsEnabled,
    shouldHideProjectManagement
  };
};

export default usePerformance;
